<template>
  <el-container class="wrapper-section-related-tours">
    <el-main>
      <h2 class="subtitle-related-tours">{{
        $t(`${base}.cities.title`, { name: country.name })
      }}</h2>

      <div class="wrapper-selector">
        <el-radio-group v-model="options.enabled" size="medium">
          <el-radio-button
            v-for="v in options.values"
            :key="v"
            :label="v"
            :value="v"
            >{{ $t(`${base}.options.${v}`) }}</el-radio-button
          >
        </el-radio-group>
      </div>

      <div v-if="options.enabled === 'items'" class="wrapper-items">
        <div class="content-link" :class="{ 'is-closed': !openItems }">
          <div v-for="item in items" :key="item.code">
            <nuxt-link
              slot="label"
              :to="{
                name: 'search-type',
                params: {
                  type: $t('router.search_type.type.city'),
                  value: item.slug,
                  tab: $t('router.search_type.tab.tours'),
                },
              }"
              @click.native="handleLoading"
            >
              {{ $t(`${base}.cities.tours_in`, { name: item.name }) }}
              <i class="el-icon-top-right" />
            </nuxt-link>
          </div>
        </div>

        <div v-if="items.length > limitMin">
          <el-button
            type="text"
            class="el-button el-button--text el-button--medium"
            @click="handleChange"
            >{{ $t(`${base}.${itemsText}`) }}</el-button
          >
        </div>
      </div>
      <div
        v-else-if="options.enabled === 'durations'"
        class="wrapper-durations"
      >
        <div class="content-link" :class="{ 'is-closed': !openDurations }">
          <div v-for="duration in durations" :key="duration">
            <nuxt-link
              slot="label"
              :to="{
                name: type === 'country' ? 'search' : 'search-type',
                query:
                  type === 'country'
                    ? {
                        type,
                        value: $route.params.value,
                        duration: [duration, duration],
                      }
                    : {},
                params:
                  type === 'country'
                    ? {}
                    : {
                        type: $t(`router.search_type.type.${type}`),
                        value: $route.params.value,
                        tab: $t('router.search_type.tab.tours'),
                        days: $t(`${base}.duration.link`, { days: duration }),
                      },
              }"
              @click.native="handleLoading"
            >
              {{ $t(`${base}.duration.tours_for`, { days: duration }) }}
            </nuxt-link>
          </div>
        </div>

        <div v-if="durations.length > limitMin">
          <el-button
            type="text"
            class="el-button el-button--text el-button--medium"
            @click="handleChange"
            >{{ $t(`${base}.${durationText}`) }}</el-button
          >
        </div>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'LadSearchRelatedTours',
  props: {
    type: { type: String, default: 'country' },
  },
  data() {
    return {
      base: 'search.country.fast_links',
      /** debe coincidir con el css */
      limitMin: 10,
      openItems: false,
      openDurations: false,
      options: {
        values: ['items', 'durations'],
        enabled: 'items',
      },
    }
  },
  computed: {
    ...mapState('country', {
      country: (state) => ({
        name: state.header.name,
        permalink: state.header.permalink,
      }),
      durations: (state) => state.durations,
    }),
    ...mapState('settings', {
      countryItem(state) {
        return state.countries.find(
          ({ slug }) => this.country.permalink.default === slug
        )
      },
    }),
    items() {
      let items = []

      switch (this.type) {
        case 'country':
          if (this.country) items = this.countryItem.cities
          break
        default:
          break
      }

      return items
    },
    itemsText() {
      return this.openItems ? 'show_less' : 'show_more'
    },
    durationText() {
      return this.openDurations ? 'show_less' : 'show_more'
    },
  },
  methods: {
    handleLoading() {
      this.$nuxt.$emit('custom-loading', { enabled: true, source: 'search' })
    },
    handleChange() {
      switch (this.options.enabled) {
        case 'durations':
          this.openDurations = !this.openDurations
          break
        case 'items':
          this.openItems = !this.openItems
          break
      }
    },
  },
}
</script>

<style lang="scss">
.wrapper-section-related-tours {
  .subtitle-related-tours {
    font-size: 48px;
    font-weight: 700;
    line-height: 57.6px;
    text-align: center;
  }

  .wrapper-selector {
    text-align: center;
    margin-bottom: 100px;

    .el-radio-group {
      padding: 8px 5px;
      border-radius: 5px;
      border: 1px solid rgba(232, 232, 232, 1);
    }

    .el-radio-button__inner {
      border-color: transparent;
    }

    .el-radio-button__orig-radio:checked + .el-radio-button__inner {
      background-color: rgba(236, 245, 255, 1);
      border-color: rgba(236, 245, 255, 1);
      box-shadow: -1px 0 0 0 rgba(236, 245, 255, 1);
      color: rgba(64, 158, 255, 1);
    }
  }

  .content-link {
    &.is-closed > div:nth-child(n + 10) {
      display: none;
    }
  }

  @media screen and (max-width: 768px) {
    .subtitle-related-tours,
    .wrapper-selector,
    .wrapper-items,
    .wrapper-durations {
      width: 90%;
      max-width: 400px;
      margin-left: auto;
      margin-right: auto;
    }

    .subtitle-related-tours {
      font-size: 24px;
    }

    .wrapper-selector {
      margin-bottom: 30px;
    }

    .wrapper-items,
    .wrapper-durations {
      padding: 15px 20px;
      margin: 0 auto;
    }
  }

  @media screen and (max-width: 465px) {
    .wrapper-durations {
      .content-link {
        grid-template-columns: repeat(2, 1fr);
      }
    }
  }
}
</style>
